exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#signatureBox[data-v-eae3edce] {\n    background-color: lightgray;\n    border: 1px dotted gray;\n}\nh4[data-v-eae3edce] {\n    color: white;\n}\n", ""]);

// exports
